import React from 'react';
import { useTranslation } from 'react-i18next';
import Typography from '../../../components/common/Typography';
import Button from '../../../components/common/Button';

const PersonalInfoConsent2Form = ({ stepHandler, personalInfoConsentHandler }) => {
  const { t } = useTranslation('eDocuments');

  return (
    <div className="displayFlexColumn" style={{ gap: '20px', paddingBottom: '40px' }}>
      <Typography variant="body1Bold">{t('linkToData.personalInfoConsent.title')}</Typography>
      <Typography variant="body2Medium" style={{ whiteSpace: 'pre-wrap' }}>
        {`국세청은 정보주체의 동의, 법률에 특별한 규정이 있는 경우 등 개인정보보호법 제17조 및 제18조에 해당하는 경우에만 개인정보를 제3자에게 제공합니다.
가. 용어의 정의
1. 연계정보(CI) : 특정 개인을 식별하기 위해 본인확인기관에서 생성한 암호화된 개인식별번호
2. 인증사업자 : 카카오, NHN페이코, 통신사패스, KB국민은행, 한국정보인증(삼성패스), 신한은행, 네이버, 토스, 하나은행, NH농협, 뱅크샐러드, 카카오뱅크, 우리은행, 드림시큐리티 등 전자서명 서비스를 제공하는 사업자
3. 본인확인기관 : 코리아크레딧뷰로(KCB) 등 본인확인 서비스를 제공하는 사업자
나. 제3자 제공에 관한 사항
1. 개인정보를 제공받는 자 : 인증사업자, 본인확인기관
2. 제공받는 자의 개인정보 이용목적 : 간편인증 시 본인확인 또는 전자서명
3. 제공하는 개인정보 항목 : 주민등록번호(외국인등록번호) 또는 생년월일(로그인 시), 성명, 휴대폰번호
4. 제공받는 자의 보유 및 이용기간 : 본인확인 또는 전자서명 후 즉시 파기
위 개인정보의 제3자 제공 동의를 거부할 수 있습니다. 다만, 관련 홈택스 이용 목적에 따른 서비스의 제한이 있을 수 있습니다.`}
      </Typography>
      <div className="stepButtonContainer">
        <Button
          value={t('linkToData.personalInfoConsent.button')}
          fullWidth
          onClick={() => personalInfoConsentHandler('personalInfoConsent2')}
        />
      </div>
    </div>
  );
};

export default PersonalInfoConsent2Form;
